module.exports = __webpack_public_path__ + "media/application/images/svgs/bold-9b8ec120dbfd927fb270ededb0000e75.svg";